var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.477,
    height: 23.218,
    viewBox: "0 0 24.477 23.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-warning",
    "data-name": "Icon metro-warning",
    d: "M14.809,4.032,25.066,23.423H4.552l3.9-7.37L14.809,4.032Zm0-2.1A1.769,1.769,0,0,0,13.354,2.94L2.906,22.692c-.8,1.35-.12,2.454,1.513,2.454H25.2c1.633,0,2.314-1.1,1.513-2.454h0L16.265,2.94a1.768,1.768,0,0,0-1.455-1.012Zm1.53,18.865a1.532,1.532,0,1,1-1.53-1.451A1.492,1.492,0,0,1,16.339,20.793Zm-1.53-2.9a1.492,1.492,0,0,1-1.53-1.451V12.086a1.532,1.532,0,0,1,3.06,0V16.44A1.492,1.492,0,0,1,14.809,17.891Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.96cb56d695e255be07d8f1a3c881d202.svg";
export { ForwardRef as ReactComponent };